'use client';

import dynamic from 'next/dynamic';
import React from 'react';

import type { Special } from '@/types/specials/specials.types';

const Promotions = dynamic(() => import('../Promotion'), { ssr: false });

type Props = {
  isDealershipPage?: boolean;
  featuredItems: Special[];
  dealershipName?: string;
};

const PromotionDynamic = ({
  dealershipName,
  featuredItems,
  isDealershipPage = false,
}: Props) => {
  return (
    <Promotions
      featuredItems={featuredItems}
      dealershipName={dealershipName}
      isDealershipPage={isDealershipPage}
    />
  );
};

export default PromotionDynamic;
